import { Box, Button, Paper, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import type { InvoiceSender } from "../../../../logic/invoice-sender";
import { AssignedStateToggle } from "../../../../components/AssignedStateToggle";
import { DatePicker } from "../../../../components/DatePicker";
import { SenderToggles } from "../../../../components/SenderToggles";
import type { Filters } from "../types";
import { defaultFilters, isDefaultFilters } from "../types";

export type InvoiceFiltersProps = {
  value: Filters;
  onChange: (next: Filters) => void;
  senderOptions: InvoiceSender[];
};

export const InvoiceFilters = ({
  value,
  onChange,
  senderOptions,
}: InvoiceFiltersProps) => {
  const update = <K extends keyof Filters>(key: K, next: Filters[K]) =>
    onChange({ ...value, [key]: next });

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <AssignedStateToggle
            label="Attachments"
            icon={<AttachFileIcon />}
            value={value.attachments}
            onChange={(v) => update("attachments", v)}
          />
        </Box>
        <SenderToggles
          options={senderOptions}
          value={value.senderKeys}
          onChange={(next) => update("senderKeys", next)}
        />
        <TextField
          size="small"
          label="Name or ID contains"
          value={value.namePattern}
          onChange={(e) => update("namePattern", e.target.value)}
          sx={{ minWidth: 220 }}
        />
        <DatePicker
          mode="range"
          label="Due date"
          value={{ from: value.from, to: value.to }}
          onChange={(next) =>
            onChange({ ...value, from: next.from, to: next.to })
          }
        />
        {!isDefaultFilters(value) && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={() => onChange(defaultFilters)}
          >
            Clear
          </Button>
        )}
      </Box>
    </Paper>
  );
};
